<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Progress</strong>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/progress"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-progress :value="counter" :max="max" show-percentage animated></c-progress>
        <c-progress class="mt-1" :max="max" show-value>
          <c-progress-bar :value="counter * (6 / 10)" color="gradient-success" />
          <c-progress-bar :value="counter * (2.5 / 10)" color="gradient-warning" />
          <c-progress-bar :value="counter * (1.5 / 10)" color="gradient-danger" />
        </c-progress>
        <c-button color="secondary" class="mt-4" @click="clicked">
          Click me to animate progress bars
        </c-button>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>labels</small>
      </c-card-header>
      <c-card-body>
        <h6>No label</h6>
        <c-progress :value="value" :max="max2" class="mb-3" />
        <h6>Value label</h6>
        <c-progress :value="value" :max="max2" show-value class="mb-3" />
        <h6>Progress label</h6>
        <c-progress :value="value" :max="max2" show-percentage class="mb-3" />
        <h6>Value label with precision</h6>
        <c-progress :value="value" :max="max2" :precision="2" show-value class="mb-3" />
        <h6>Progress label with precision</h6>
        <c-progress :value="value" :max="max2" :precision="2" show-percentage class="mb-3" />
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>width</small>
      </c-card-header>
      <c-card-body>
        <h6>Default width</h6>
        <c-progress :value="value3" class="mb-3" />
        <h6>Custom widths</h6>
        <c-progress :value="value3" class="w-75 mb-2" />
        <c-progress :value="value3" class="w-50 mb-2" />
        <c-progress :value="value3" class="w-25" />
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>height</small>
      </c-card-header>
      <c-card-body>
        <h6>Default height</h6>
        <c-progress :value="value3" show-percentage class="mb-3" />
        <h6>Custom heights</h6>
        <c-progress height="2rem" :value="value3" show-percentage class="mb-2" />
        <c-progress height="20px" :value="value3" show-percentage class="mb-2" />
        <c-progress height="2px" :value="value3" />
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>colors</small>
      </c-card-header>
      <c-card-body>
        <div v-for="(bar, index) in bars" :key="index" class="row mb-1">
          <div class="col-sm-2">{{ bar.color }}:</div>
          <div class="col-sm-10 pt-1">
            <c-progress :key="bar.color" :value="bar.value" :color="bar.color" />
          </div>
        </div>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>striped</small>
      </c-card-header>
      <c-card-body>
        <c-progress :value="25" color="success" :striped="striped" class="mb-2" />
        <c-progress :value="50" color="info" :striped="striped" class="mb-2" />
        <c-progress :value="75" color="warning" :striped="striped" class="mb-2" />
        <c-progress :value="100" color="danger" :striped="striped" class="mb-2" />
        <c-button color="secondary" @click="striped = !striped">{{ striped ? 'Remove' : 'Add' }} Striped</c-button>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>animated</small>
      </c-card-header>
      <c-card-body>
        <c-progress :value="25" color="success" striped :animated="animate" class="mb-2" />
        <c-progress :value="50" color="info" striped :animated="animate" class="mb-2" />
        <c-progress :value="75" color="warning" striped :animated="animate" class="mb-2" />
        <c-progress :value="100" color="danger" :animated="animate" class="mb-3" />
        <c-button color="secondary" @click="animate = !animate">{{ animate ? 'Stop' : 'Start' }} Animation</c-button>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Progress</strong>
        <small>multiple bars</small>
      </c-card-header>
      <c-card-body>
        <c-progress :max="max3" class="mb-3">
          <c-progress-bar color="gradient-primary" :value="values[0]" />
          <c-progress-bar color="gradient-success" :value="values[1]" />
          <c-progress-bar color="gradient-info" :value="values[2]" />
        </c-progress>
        <c-progress show-percentage :max="max3" class="mb-3">
          <c-progress-bar color="gradient-primary" :value="values[0]" />
          <c-progress-bar color="gradient-success" :value="values[1]" />
          <c-progress-bar color="gradient-info" :value="values[2]" />
        </c-progress>
        <c-progress show-value striped :max="max3" class="mb-3">
          <c-progress-bar color="gradient-primary" :value="values[0]" />
          <c-progress-bar color="gradient-success" :value="values[1]" />
          <c-progress-bar color="gradient-info" :value="values[2]" />
        </c-progress>
        <c-progress :max="max3" class="mb-3">
          <c-progress-bar color="gradient-primary" :value="values[0]" show-percentage />
          <c-progress-bar color="success" :value="values[1]" animated show-percentage />
          <c-progress-bar color="gradient-info" :value="values[2]" striped show-percentage />
        </c-progress>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'ProgressBars',
  data() {
    return {
      counter: 73,
      max: 100,
      max2: 50,
      value: 33.333333333,
      value3: 75,
      bars: [
        { color: 'gradient-success', value: 75 },
        { color: 'gradient-info', value: 75 },
        { color: 'gradient-warning', value: 75 },
        { color: 'gradient-danger', value: 75 },
        { color: 'gradient-primary', value: 75 },
        { color: 'gradient-secondary', value: 75 },
        { color: 'gradient-dark', value: 75 },
      ],
      timer: null,
      striped: true,
      animate: true,
      max3: 100,
      values: [15, 30, 20],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.bars.forEach((bar) => {
        bar.value = 25 + Math.random() * 75;
      });
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    clicked() {
      this.counter = Math.random() * this.max;
    },
  },
};
</script>
